module.exports = __webpack_public_path__ + "static/button-space-7c3d0b1e2218928206173757f709eda1.png";